<template>
  <div class="d-inline-block" v-if="isUserAprovador && isPendente">
    <template v-if="showAsButtons">
      <v-btn color="success" small
             class="ml-1 normal-btn-text rounded-tag-small elevation-0"
             :loading="loading"
             :disabled="loadingRecusa"
             @click="aprovar">
        <v-icon small>mdi-check</v-icon>
        Aprovar
      </v-btn>
      <px-aprovacao-recusar-dialog :loading="loadingRecusa"
                                   @recusar="onClickRecusar">
        <template v-slot:activator="{ on }">
          <v-btn color="error" small
                 class="ml-1 normal-btn-text rounded-tag-small elevation-0"
                 :disabled="loading"
                 v-on="on">
            <v-icon small>mdi-close</v-icon>
            Recusar
          </v-btn>
        </template>
      </px-aprovacao-recusar-dialog>
    </template>
    <template v-else>
      <v-btn icon color="success" class="ml-1"
             :loading="loading"
             :disabled="loadingRecusa"
             @click="aprovar">
        <v-icon>mdi-check</v-icon>
      </v-btn>
      <px-aprovacao-recusar-dialog :loading="loadingRecusa"
                                   @recusar="onClickRecusar">
        <template v-slot:activator="{ on }">
          <v-btn icon color="error" :disabled="loading" v-on="on">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </px-aprovacao-recusar-dialog>
    </template>
  </div>
</template>

<script>
import {
  getProdutosPendentesPorAprovador,
  isUserAprovadorSolicitacao,
} from '@/modules/aprovacao-solicitacao/aprovador-solicitacao-utils';
import { mapGetters } from 'vuex';
import AprovacaoCompraService from '@/modules/aprovacao-compra/aprovacao-compra-service';
import { SituacaoAprovacao } from 'px-business-components';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
    showAsButtons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      loadingRecusa: false,
    };
  },
  computed: {
    ...mapGetters('user', ['user']),
    isUserAprovador() {
      return isUserAprovadorSolicitacao(this.user, this.aprovacao);
    },
    isPendente() {
      return this.aprovacao.produtos.some(p => p.situacao === SituacaoAprovacao.keys.PENDENTE.key);
    },
  },
  methods: {
    aprovar() {
      this.loading = true;
      const produtosPendentes = getProdutosPendentesPorAprovador(this.user, this.aprovacao);
      const payload = produtosPendentes.map(p => ({
        id: p.id,
      }));
      AprovacaoCompraService.aprovarProdutos(this.aprovacao.id, payload)
        .then(({ data }) => {
          this.$emit('update', data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickRecusar(payloadRecusa) {
      this.loadingRecusa = true;
      const produtosPendentes = getProdutosPendentesPorAprovador(this.user, this.aprovacao);
      const payload = produtosPendentes.map(p => ({
        ...payloadRecusa,
        id: p.id,
      }));
      AprovacaoCompraService.recusarProdutos(this.aprovacao.id, payload)
        .then(({ data }) => {
          this.$emit('update', data);
        })
        .finally(() => {
          this.loadingRecusa = false;
        });
    },
  },
};
</script>
